import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '@com/core/common/styles/baseStyles';
import { TBannerModuleCarousel } from '@com/core/common/types/catalog';
import ModuleHeader from '../moduleHeader/moduleHeader';
import BannerContent from '../bannerModule/bannerContent/bannerContent';

const BannerCarousel = styled.div`
    white-space: nowrap;
    padding-top: 5px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;

    @media ${breakpoints.minDesktop} {
        white-space: normal;
        overflow: visible;
        padding: 0;
        text-align: center;
    }
`;

const BannerSlide = styled.div<{ numPerView: number }>`
    width:  ${({ numPerView }): string => `${100 / numPerView - numPerView / 2}%`};
    display: inline-block;
    vertical-align: top;
    white-space: initial;

    & + & {
        margin-left: 15px;
    }

    ${(props): string =>
        props.theme.isRTL
            ? `& + & {
        margin-right: 15px;
        margin-left: 0;
    }`
            : ''}

    @media ${breakpoints.minDesktop} {
        width: 8%;
        padding-left: 15px;
        padding-bottom: 15px;
        box-sizing: border-box;
        margin-left: 0;
        margin-right: 15px;

        ${(props): string =>
            props.theme.isRTL
                ? `
        margin-right: 0;
        margin-left: 15px;`
                : ''}
    }
`;

type TProps = {
    moduleData: TBannerModuleCarousel;
};

// THIS MODULE SCROLLS ON TABLET BUT IS FIXED FOR DESKTOP
const BannerModuleCarousel = ({ moduleData }: TProps): JSX.Element => {
    const { banners, moduleHeader, numPerView, textColor } = moduleData;
    return (
        <div>
            {moduleHeader && <ModuleHeader className="siteWidthContainer" data={moduleHeader} textColor={textColor} />}
            <BannerCarousel className="siteWidthContainer">
                {banners.map(banner => (
                    <BannerSlide key={banner.imageUrl} numPerView={numPerView}>
                        <BannerContent bannerData={banner} />
                    </BannerSlide>
                ))}
            </BannerCarousel>
        </div>
    );
};

export default BannerModuleCarousel;
